<template>
  <div class="w-full">
    <!-- Label + Error -->
    <div
      v-if="field.type !== 'empty'"
      class="flex items-baseline justify-between mb-1"
    >
      <label class="block text-s">{{ field.label }} :</label>
      <span
        v-if="errors[field.model]"
        class="text-xs text-red-500 font-medium ml-2"
      >
        {{ errors[field.model] }}
      </span>
    </div>

    <!-- AutoComplete for Sold To -->
    <AutoComplete
      v-if="field.model === 'soldTo'"
      v-model="formData.soldTo"
      :suggestions="suggestions"
      optionLabel="Companies"
      :minLength="3"
      placeholder="Enter payee name"
      class="w-full rounded-md"
      :inputClass="'w-full bg-white text-gray-700 rounded-md py-2 px-3 border'"
      @complete="searchCompany"
      @item-select="selectCompany"
    />

    <!-- Text / Date / Number -->
    <input
      v-else-if="['text', 'date', 'number'].includes(field.type)"
      :type="field.type"
      v-model="formData[field.model]"
      :placeholder="field.placeholder || ''"
      class="w-full rounded-md p-2 border transition-colors duration-200"
      :class="errors[field.model] ? 'border-red-500' : 'border-gray-300'"
    />

    <!-- Regular Textarea -->
    <textarea
      v-else-if="field.type === 'textarea' && field.label !== 'Description'"
      :rows="field.rows || 2"
      v-model="formData[field.model]"
      :placeholder="field.placeholder || ''"
      class="w-full rounded-md p-2 border resize-none transition-colors duration-200"
      :class="errors[field.model] ? 'border-red-500' : 'border-gray-300'"
    ></textarea>

    <!-- Description -->
    <textarea
      v-else-if="field.type === 'textarea' && field.label === 'Description'"
      :rows="field.rows || 2"
      :value="formData.invoice_items[0]?.description || ''"
      @input="
        (e) => {
          // ensure invoice_items[0] exists
          if (!formData.invoice_items.length)
            formData.invoice_items.push({
              description: '',
              quantity: 0,
              cost: 0,
              items_total: 0,
            });
          formData.invoice_items[0].description = e.target.value;
        }
      "
      :placeholder="field.placeholder || ''"
      class="w-full rounded-md p-2 border resize-none transition-colors duration-200"
      :class="[
        formData.invoice_items[0]?.description?.trim()
          ? 'border-green-500'
          : 'border-red-500',
        errors[field.model] ? 'border-red-500' : '',
      ]"
      @blur="$emit('blur-description')"
    ></textarea>

    <!-- Select -->
    <select
      v-else-if="field.type === 'select'"
      v-model="formData[field.model]"
      class="w-full rounded-md p-2 border transition-colors duration-200"
      :class="errors[field.model] ? 'border-red-500' : 'border-gray-300'"
    >
      <option
        v-for="(option, oIndex) in field.options"
        :key="oIndex"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
import { ref, inject } from "vue";

export default {
  name: "InvoiceFormFields",
  components: { AutoComplete },
  props: {
    field: Object,
    formData: Object,
    errors: Object,
    newDescription: String,
  },
  emits: ["update:newDescription", "blur-description"],
  setup(props, { emit }) {
    const axios = inject("$axios");

    const suggestions = ref([]);

    const searchCompany = async (event) => {
      const query = event.query?.trim();
      if (!query) {
        suggestions.value = [];
        return;
      }

      try {
        const res = await axios.get("/api/invoice/get/company", {
          params: { name: query },
        });
        console.log(res);
        suggestions.value = res.data.data || [];
      } catch (err) {
        console.error(err);
        suggestions.value = [];
      }
    };

    const selectCompany = (company) => {
      if (!company) return;

      suggestions.value = [];

      // Determine the actual company name
      let companyName = "";
      if (company.value.sold_to) {
        companyName = company.value.sold_to;
      } else if (company.value.Companies) {
        companyName = company.value.Companies;
      }

      emit("update:soldToData", {
        soldTo: companyName,
        tin: company.value.tin || undefined,
        address: company.value.address || undefined,
      });
    };

    return { suggestions, searchCompany, selectCompany };
  },
};
</script>
